import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';

export default {
  getNoticeByRole() {
    return axiosPlataformaClient.custAxios().get('academic/notices/me');
  },
  getHighlightedNotice() {
    return axiosPlataformaClient.custAxios().get("academic/notices-board/me/highlight");
  },
  sendAgreedNotice({ noticeId, hasAgreed }) {
    return axiosPlataformaClient.custAxios().patch(`academic/notices/${noticeId}/action`, { hasAgreed });
  }
};
